import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DynamicFieldListLayer from "../../components/DynamicField/DynamicFieldListLayer";

const DynamicFieldListPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Preferences" />
        <DynamicFieldListLayer />
      </MasterLayout>
    </>
  );
};

export default DynamicFieldListPage;
